<template>
<div id="app" :class="{ preview: $route.name === 'preview' }">
  <navigation></navigation>
  <logo></logo>
  <router-view :key="$route.path"></router-view>
</div>
</template>

<script>
import EventBus from './util/EventBus'
import * as types from './store/mutation-types'
import Navigation from './components/Navigation.vue'
import Logo from './components/Logo.vue'

export default {
  name: 'app',
  components: {
    Navigation,
    Logo
  },
  data() {
    return {}
  },
  beforeCreate() {
    this.$store.commit(types.RECEIVE_PAGES, {
      pages: window.Kirby.pages
    })
    this.$store.commit(types.RECEIVE_SITE, {
      site: window.Kirby.site
    })
  },
  created() {
    window.addEventListener('resize', this.onResize, true)
    window.addEventListener('scroll', this.onScroll)
    window.addEventListener('orientationchange', this.onOrientationChange)

    this.onResize()
  },
  destroyed() {
    window.removeEventListener('resize', this.onResize, true)
    window.removeEventListener('scroll', this.onScroll)
    window.removeEventListener('orientationchange', this.onOrientationChange)
  },
  methods: {
    onResize(event) {
      var windowWidth = window.innerWidth || document.documentElement.clientWidth || document.getElementsByTagName('body')[0].clientWidth
      this.$store.commit(types.UPDATE_APP, {
        field: 'tablet',
        value: windowWidth <= 960
      })
      this.$store.commit(types.UPDATE_APP, {
        field: 'phone',
        value: windowWidth <= 480
      })

      EventBus.$emit('app.resize', event)
    },
    onScroll(event) {
      EventBus.$emit('app.scroll', event)
    },
    onOrientationChange(event) {
      EventBus.$emit('app.orientationchange', event)
    }
  }
}
</script>

<style lang="scss">
@import 'node_modules/reset-css/sass/_reset';
@import './assets/styles/base';
@import './assets/fonts/PlainMedium-Regular.css';

* {
    box-sizing: border-box;
    -webkit-tap-highlight-color: rgba(0,0,0,0);
    -webkit-tap-highlight-color: transparent;
}

html {
    font-family: $font-family;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-text-size-adjust: 100%;
    text-rendering: optimizeLegibility;
    font-size: 1vmin;
    color: $font-color;
}

body,
html {
    width: 100%;
    height: 100%;
    line-height: $line-height;
    background: $bgcolor;
    @media only screen and (max-width: $phone) {
        line-height: $line-height * 1.125;
    }
    overflow-x: hidden;
}

#app {
    width: 100%;
    height: 100%;
    font-size: $font-size;
    @media only screen and (max-width: $phone) {
        font-size: $font-size / 2;
    }
    &:after {
        content: '';
        display: block;
        width: $gap * 2;
        border-bottom: 2px solid $font-color;
        @media only screen and (max-width: $phone) {
            border-bottom: 1px solid $font-color;
        }
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        pointer-events: none;
        z-index: 10;
    }
}

main {
    position: absolute;
    width: 50%;
    top: 0;
    right: 0;
    background: $bgcolor;
    z-index: 9;
    padding: $gap / 2 $gap / 2 $gap / 2 0;
    transition: right 1s ease;
    @media only screen and (max-width: $tablet) {
        // width:50vh;
    }
}

section {
    margin-bottom: $gap * 4;
    padding: $gap / 2 0;
    border-bottom: 2px solid $font-color;
    @media only screen and (max-width: $phone) {
        border-bottom: 1px solid $font-color;
    }
    #testimonials {
        padding-top: $gap / 2;
    }
    &#intro {
        padding:0;
        height: 100vh;
        margin-bottom: 0;
        border-bottom:0;
    }
    &.no-pad {
        padding-bottom:0;
        border-bottom:0;
    }

    &#credits {
        margin-bottom: $gap / 2;
    }
}

h1,
h2,
h3,
h4,
h5,
h6,
p {
    font-weight: normal;
    margin-bottom: $gap;
    hyphens: auto;
    @media only screen and (max-width: $phone) {
        margin-bottom: $gap / 1.65;
    }
}

h1 {
    padding-bottom: $gap / 2;
    margin-bottom: $gap / 2;
    border-bottom: 2px solid $font-color;
    &.no-pad {
        margin-bottom: 0;
    }
    &.mega-pad {
        margin-top: $gap * 2;
    }
    @media only screen and (max-width: $phone) {
        border-bottom: 1px solid $font-color;
    }
}

a {
    position: relative;
    color: $font-color;
    text-decoration: none;
    transition: transform 0.5s;
    &:not(.no-line) {
        &.router-link-exact-active,
        &:hover {
            &:before {
                content: '';
                position: absolute;
                width: 100%;
                border-bottom: 2px solid $font-color;
                @media only screen and (max-width: $phone) {
                    border-bottom: 1px solid $font-color;
                }
                bottom: 0.6rem;

            }
        }
    }
}

h2 {
    padding-top: $gap;
    hyphens: none;
}

p:last-of-type {
    margin-bottom: 0;
}

em,
i {
    font-style: italic;
}

strong {
    font-weight: bold;
}

blockquote {
    padding: 0 1rem;
    position: relative;
    display: inline-block;
    margin-bottom: 1rem;

    &:before {
        content: "“";
        position: absolute;
        left: 0;
        top: 0;
    }

    &:after {
        content: "”";
        position: absolute;
        right: 0;
        bottom: -0.5rem;
    }
}

ul {
    list-style-type: none;
    padding: 0;
}

li {
    display: inline-block;
    margin: 0;
}

img {
    max-width: 100%;
    height: auto;
}

hr {
    border-color: $font-color;
    margin: 1rem 0;
    border-style: solid;
}

figure {
    margin-bottom: 1rem;
}

figure.video {
    height: 0;
    padding-bottom: 56.25%;
    position: relative;
    background-color: lightgray;

    iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }
}
</style>
